class FooterNewsletter {
  constructor() {
    this.newsletterTrigger = document.querySelector('.newsletter-trigger');
    this.newsletterPopup = document.getElementById('newsletter-popup');
    this.newsletterClose = document.querySelector('.newsletter-popup__close');
    this.newsletterOverlay = document.querySelector('.newsletter-popup__overlay');

    this.newsletterMessages = document.querySelector('.footer-newsletter-messages');
    if (!this.newsletterMessages) {
      this.newsletterMessages = document.createElement('div');
      this.newsletterMessages.className = 'footer-newsletter-messages';
      document.body.appendChild(this.newsletterMessages);
    }

    this.init();
    this.checkUrlParams();
  }

  init() {
    if (this.newsletterTrigger && this.newsletterPopup) {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    this.newsletterTrigger.addEventListener('click', () => this.openPopup());
    this.newsletterClose.addEventListener('click', () => this.closePopup());
    this.newsletterOverlay.addEventListener('click', () => this.closePopup());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.newsletterPopup.classList.contains('active')) {
        this.closePopup();
      }
    });

    const form = this.newsletterPopup.querySelector('form');
  }

  openPopup() {
    this.newsletterPopup.classList.add('active');
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
      const input = this.newsletterPopup.querySelector('input[type="email"]');
      if (input) {
        input.focus();
      }
    }, 300);
  }

  closePopup() {
    this.newsletterPopup.classList.remove('active');
    document.body.style.overflow = '';
  }

  async handleFormSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);
    const submitButton = form.querySelector('button[type="submit"]');
    const originalText = submitButton ? submitButton.innerHTML : '';

    if (submitButton) {
      submitButton.innerHTML = 'Submitting...';
      submitButton.disabled = true;
    }

    try {
      const response = await fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        const result = await response.json();

        if (result.success) {
          this.showMessage('Thank for subscribing!', true);
          this.closePopup();
          form.reset();
        } else {
          const errorMsg = result.errors ? result.errors.email || 'Something went wrong' : 'Something went wrong';
          this.showMessage(errorMsg, false);
        }
      } else {
        this.showMessage('Server error. Please try again.', false);
      }
    } catch (error) {
      this.showMessage('Network error. Please check your connection.', false);
    } finally {
      if (submitButton) {
        submitButton.innerHTML = originalText;
        submitButton.disabled = false;
      }
    }
  }

  checkUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const newsletterSuccess = urlParams.get('customer_posted');
    const newsletterError = urlParams.get('form_type') === 'customer' && urlParams.get('error');

    if (newsletterSuccess) {
      this.showMessage('Thank you for subscribing!', true);
    } else if (newsletterError) {
      const errorMessage = urlParams.get('message') || 'Something went wrong. Please try again.';
      this.showMessage(errorMessage, false);
    }
  }

  showMessage(message, isSuccess = true) {
    if (!this.newsletterMessages) return;

    const existingMessage = this.newsletterMessages.querySelector('.footer-newsletter-message');
    if (existingMessage) {
      existingMessage.remove();
    }

    const messageEl = document.createElement('div');
    messageEl.className = `footer-newsletter-message ${isSuccess ? 'footer-newsletter-success' : 'footer-newsletter-error'}`;

    const iconSvg = isSuccess ? `
            <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" width="20" height="20">
                <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L8 12.17l-2.59-2.58L4 11l4 4 8-8z" fill="currentColor"/>
            </svg>
        ` : `
            <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" width="20" height="20">
                <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h-2v-2h2v2zm0-4h-2V6h2v4z" fill="currentColor"/>
            </svg>
        `;

    messageEl.innerHTML = `
            ${iconSvg}
            <span>${message}</span>
            <button class="footer-message-close" type="button" aria-label="Close">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4L4 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        `;

    this.newsletterMessages.appendChild(messageEl);
    const closeBtn = messageEl.querySelector('.footer-message-close');
    closeBtn.addEventListener('click', () => {
      this.removeMessage(messageEl);
    });

    setTimeout(() => {
      if (messageEl.parentNode === this.newsletterMessages) {
        this.removeMessage(messageEl);
      }
    }, 10000);
  }

  removeMessage(messageEl) {
    messageEl.classList.add('fade-out');
    setTimeout(() => {
      if (messageEl.parentNode === this.newsletterMessages) {
        messageEl.remove();
        const url = new URL(window.location);
        url.searchParams.delete('customer_posted');
        url.searchParams.delete('form_type');
        url.searchParams.delete('error');
        url.searchParams.delete('message');
        window.history.replaceState({}, '', url);
      }
    }, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new FooterNewsletter();
});